module.exports = __webpack_public_path__ + "static/media/invoicingar_cc_pay_guide_4.3a379a68.png";